const isAbortError = (error) => error?.name === "AbortError";

const ABORT_MESSAGE_SNIPPETS = ["signal is aborted without reason"];

/** Apollo/fetch abort on the error or its networkError, plus known abort messages. */
export const isRequestAbortError = (error) => {
  if (!error) {
    return false;
  }
  if (isAbortError(error) || isAbortError(error.networkError)) {
    return true;
  }
  const messages = [error.message, error.networkError?.message].filter(Boolean);
  return messages.some(
    (message) =>
      typeof message === "string" &&
      ABORT_MESSAGE_SNIPPETS.some((snippet) => message.includes(snippet))
  );
};

export default isAbortError;
